import { COUNTRY_PHONE_CODES } from "@biggeo/bg-utils";
import { PhoneViewInput } from "@vividtheory/minerva-lab";
import { getIn, useFormikContext } from "formik";
import React from "react";
import { CountryIcon } from "../icons";
import { Country } from "@biggeo/bg-server-lib/studio";
import { startCase } from "lodash";
export const FormikPhoneField = (props) => {
    var _a;
    const formik = useFormikContext();
    const error = getIn(formik.errors, props.name);
    const handleBlur = () => {
        formik.setFieldTouched(props.name, true);
    };
    const touched = getIn(formik.touched, props.name);
    const _value = getIn(formik.values, props.name);
    const phoneCountryCode = getIn(formik.values, "phoneCountryCode");
    const countryCodes = Object.values(Country).map((country) => {
        const label = startCase(country);
        return {
            value: COUNTRY_PHONE_CODES[label] || 1,
            label: label,
            icon: (React.createElement(CountryIcon, { country: country, isClientRendered: false })),
        };
    });
    const moveValueToFront = (arr, searchValue, searchLabel) => {
        const itemToMove = searchLabel
            ? arr.find((item) => item.value === searchValue && item.label === searchLabel)
            : arr.find((item) => item.value === searchValue);
        if (!itemToMove) {
            return arr; // Value not found
        }
        const filteredArr = arr.filter((item) => item !== itemToMove);
        return [itemToMove, ...filteredArr];
    };
    const reformatted = moveValueToFront(countryCodes, Number(phoneCountryCode));
    return (React.createElement(PhoneViewInput, Object.assign({ onChange: (_, val) => {
            formik.setValues((p) => {
                var _a;
                return (Object.assign(Object.assign({}, p), { [props.name]: (val === null || val === void 0 ? void 0 : val.phoneNumber) === "" ? undefined : val === null || val === void 0 ? void 0 : val.phoneNumber, phoneCountryCode: (_a = val === null || val === void 0 ? void 0 : val.countryCode) === null || _a === void 0 ? void 0 : _a.toString() }));
            });
        }, value: _value === "" ? undefined : _value, error: touched && !!error, errorText: touched && !!error
            ? "Phone number must contain at least 10 numbers"
            : "", onBlur: handleBlur, countryCodes: reformatted, removePredefinedCountryCodes: true, disableFormatting: phoneCountryCode !== ((_a = COUNTRY_PHONE_CODES.Canada) === null || _a === void 0 ? void 0 : _a.toString()) }, props)));
};
//# sourceMappingURL=FormikPhoneField.js.map